import React from 'react'
import styled from 'styled-components'
import Logo from '../../molecules/share/Logo'
import SignupButton from '../../atoms/SignupButton'
import LoginButton from '../../atoms/LoginButton'

export const Header = () => {
  return (
    <HeaderArea>
      <Logo />
      <Buttons>
        <LoginButton />
      </Buttons>
    </HeaderArea>
  )
}

const HeaderArea = styled.header`
  display: flex;
  width: 100%;
  height: 80px;
  position: fixed;
  background-color:  #ffffff;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 20px 80px;
  align-items: center;
  z-index: 100;
`
const Buttons = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 3rem;
  width: 20%;
  @media screen and (max-width: 1000px) {
    width: 40%;
  }
`

export default Header
